export const YEARLY_DISCOUNT = 0.1; // 10% discount

export const revenueTiers = [
  { label: "$0 – $500K", min: 0, max: 500000, essentials: 199, complete: 499 },
  {
    label: "$500K – $1.5M",
    min: 500000,
    max: 1500000,
    essentials: 299,
    complete: 699,
  },
  {
    label: "$1.5M – $3M",
    min: 1500000,
    max: 3000000,
    essentials: 399,
    complete: 899,
  },
  {
    label: "$3M – $6M",
    min: 3000000,
    max: 6000000,
    essentials: 599,
    complete: 1299,
  },
  {
    label: "$6M – $10M",
    min: 6000000,
    max: 10000000,
    essentials: 799,
    complete: 1799,
  },
  {
    label: "$10M+",
    min: 10000000,
    max: null,
    essentials: null,
    complete: null,
  },
];

export const essentialsFeatures = [
  "AI-Powered Transaction Categorisation",
  "Monthly Bookkeeping & Reconciliation",
  "Profit & Loss Report",
  "Cash Flow Report",
  "Balance Sheet Report",
  "Dedicated Accountant Review",
  "Xero Integration",
];

export const completeFeatures = [
  "Everything in Essentials",
  "BAS Preparation & Lodgement",
  "ATO Compliance & Reporting",
  "PAYG Withholding Summaries",
  "STP (Single Touch Payroll) Compliance",
  "Annual Tax Return Preparation",
  "Monthly Review Meetings",
];

export const addons = [
  {
    name: "Payroll Services",
    price: 99,
    description:
      "End-to-end payroll processing so you never miss a pay run. We handle calculations, payslips, super contributions, and Single Touch Payroll reporting — all on time, every time.",
    features: [
      "Weekly, fortnightly, or monthly pay runs",
      "Payslip generation & distribution",
      "Superannuation calculations & payments",
      "STP Phase 2 reporting to ATO",
      "Leave & entitlement tracking",
      "Employee onboarding & TFN setup",
    ],
  },
  {
    name: "CFO Advisory",
    price: 499,
    description:
      "Strategic financial guidance from experienced advisors who understand Australian businesses. Get the insights you need to grow with confidence.",
    features: [
      "Monthly financial strategy sessions",
      "Cash flow forecasting & analysis",
      "Budget vs actuals reporting",
      "KPI dashboard & tracking",
      "Growth & profitability analysis",
      "Board-ready financial packs",
    ],
  },
  {
    name: "ASIC Compliance",
    price: 149,
    description:
      "Stay on top of your ASIC obligations without lifting a finger. We handle company registrations, annual reviews, and ongoing compliance monitoring.",
    features: [
      "Company registration & setup",
      "Annual company statements",
      "ASIC annual review lodgement",
      "Director & shareholder changes",
      "Registered office & agent services",
      "Compliance calendar & reminders",
    ],
  },
  {
    name: "BAS Lodgement",
    price: 199,
    description:
      "Quarterly BAS preparation and lodgement handled by experts. We reconcile your GST, review your data, and lodge directly with the ATO.",
    features: [
      "Quarterly BAS preparation",
      "GST reconciliation & review",
      "PAYG instalment calculations",
      "Direct ATO lodgement",
      "BAS revision & amendment support",
      "Pre-lodgement review meeting",
    ],
  },
];

export const comparisonCategories = [
  {
    name: "Bookkeeping",
    features: [
      {
        name: "AI-Powered Transaction Categorisation",
        essentials: true,
        complete: true,
      },
      {
        name: "Monthly Bookkeeping & Reconciliation",
        essentials: true,
        complete: true,
      },
      { name: "Xero Integration", essentials: true, complete: true },
      {
        name: "Dedicated Accountant Review",
        essentials: true,
        complete: true,
      },
    ],
  },
  {
    name: "Reporting",
    features: [
      { name: "Profit & Loss Report", essentials: true, complete: true },
      { name: "Cash Flow Report", essentials: true, complete: true },
      { name: "Balance Sheet Report", essentials: true, complete: true },
      { name: "Monthly Review Meetings", essentials: false, complete: true },
    ],
  },
  {
    name: "Tax & Compliance",
    features: [
      {
        name: "BAS Preparation & Lodgement",
        essentials: false,
        complete: true,
      },
      {
        name: "ATO Compliance & Reporting",
        essentials: false,
        complete: true,
      },
      {
        name: "PAYG Withholding Summaries",
        essentials: false,
        complete: true,
      },
      {
        name: "STP (Single Touch Payroll) Compliance",
        essentials: false,
        complete: true,
      },
      {
        name: "Annual Tax Return Preparation",
        essentials: false,
        complete: true,
      },
    ],
  },
  {
    name: "Support",
    features: [
      { name: "Email Support", essentials: true, complete: true },
      { name: "Priority Support", essentials: false, complete: true },
      { name: "Dedicated Account Manager", essentials: false, complete: true },
    ],
  },
];

export const faqItems = [
  {
    question: "When should I switch from outsourced bookkeeping to Ledgerowl?",
    answer:
      "If you're spending too much time waiting for reports, reconciling data manually, or struggling with software that wasn't built for your business — it's time to switch. Ledgerowl is ideal for businesses ready to scale with real-time financial visibility.",
  },
  {
    question:
      "What makes Ledgerowl different from using Xero or QuickBooks with an outsourced bookkeeper?",
    answer:
      "Outsourced bookkeepers use generic tools like Xero or QuickBooks, which require manual data entry and third-party integrations. Ledgerowl combines purpose-built software with expert services, giving you automation, real-time data, and a dedicated team — all in one platform.",
  },
  {
    question: "Can Ledgerowl work alongside my existing accountant?",
    answer:
      "Absolutely. Many firms and accountants partner with Ledgerowl to leverage our real-time financials, automated reconciliation, and compliance tools — enabling them to focus on strategic advisory rather than data entry.",
  },
  {
    question: "Is Ledgerowl more cost-effective than outsourced bookkeeping?",
    answer:
      "Yes. Outsourced bookkeeping often requires separate costs for the bookkeeper, accounting software, and integration tools. Ledgerowl bundles software, integrations, and expert services into one transparent price — typically saving businesses 40-60% compared to traditional setups.",
  },
  {
    question: "How long does it take to onboard with Ledgerowl?",
    answer:
      "Most businesses are fully onboarded within days, not weeks. Our native integrations pull in your data automatically, and our team handles the migration so you don't have to lift a finger.",
  },
];

export const testimonials = [
  {
    quote:
      "Switching to Ledgerowl saved us over $2,000 a month compared to our old bookkeeper. The AI catches things our previous accountant missed.",
    name: "Sarah Mitchell",
    role: "Director",
    company: "Mitchell & Co Logistics",
  },
  {
    quote:
      "The Complete plan handles everything — BAS, tax returns, compliance. I haven't thought about bookkeeping in months.",
    name: "James Chen",
    role: "Founder",
    company: "Zenith Digital Agency",
  },
  {
    quote:
      "Having a dedicated accountant review AI-processed books gives us the best of both worlds. Fast, accurate, and trustworthy.",
    name: "Priya Sharma",
    role: "CFO",
    company: "GreenLeaf Foods",
  },
];
